import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { ArchiveArchiveIndexSet } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const getArchiveIndexSetCOverview = async () => ArchiveArchiveIndexSet.indexSetOverview();
export const ARCHIVE_INDEX_SET_OVERVIEW_QUERY_KEY = "archive_index_set_overview";
const refetchInterval = 5e3;
const useArchiveIndexSetOverview = ({ enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [ARCHIVE_INDEX_SET_OVERVIEW_QUERY_KEY],
    queryFn: () => defaultOnError(
      getArchiveIndexSetCOverview(),
      i18n.t("notifications.fetch_index_set_overview_failed", { ns: "enterprise_archive" }),
      i18n.t("notifications.fetch_index_set_overview_failed_title", { ns: "enterprise_archive" })
    ),
    refetchInterval,
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useArchiveIndexSetOverview;
